import { Directive, OnChanges, Input, SimpleChanges } from '@angular/core';
import { NgControl, FormControl } from '@angular/forms';

@Directive({
  selector: '[appEmptyValue]'
})
export class EmptyValueDirective implements OnChanges {

  @Input('appEmptyValue')
  clear: boolean;

  input: NgControl;

  constructor(private ngControl: NgControl) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.clear.currentValue) {
      // TODO: Estudar o angular Life Cycle e remover esse setTimeout
      // Atualmente estamos usando pois essa diretiva entra em conflito com a [appCheck]
      setTimeout(() => {             
        this.ngControl.reset(null);
      }, 0);
    }
  }

}
